<template>
  <VRow class="error_background_div" no-gutters>
    <VCol cols="12" md="6" align="center" justify="space-between">
      <v-card id="error_404_card" variant="text">
        <img class="error_404_image" :src="getResourceUrl('/maya/SL-favicon.ico')" alt="404 Error" />
        <v-card-title id="error_404_title">Oops, This Page Does Not Exist</v-card-title>
        <v-card-text id="error_404_message">Head back over to your dashboard to continue.</v-card-text>
        <v-btn id="error_404_button" @click="goHome">Go To Dashboard</v-btn>
      </v-card>
    </VCol>
  </VRow>
</template>

<script lang="ts" setup>
import { useRouter } from 'vue-router';
// Import variables from services to use in components
import { getResourceUrl } from '@/services/admin_actions/apiUtils';

const router = useRouter();

const goHome = () => {
  router.push('/');
};
</script>

<style lang="scss">
// Error 404 Page Styles
#error_404_card {
  padding: 60px 20px;
}

// Error 404 Image Styles
.error_404_image {
  height: 100px;
  width: 100px;
  margin-bottom: 20px;
}

// Error 404 Title Styles
#error_404_title {
  @include h1-global;
  font-size: 3.5rem;
  color: $primary-700;
  font-family: $mongoose-font;
  margin-bottom: 10px;
}

// Error 404 Message Styles
#error_404_message {
  font-size: 1.2rem;
  color: $white;
  font-weight: 300;
  margin-bottom: 30px;
}

// Add Background Image To Search Page
.error_background_div {
  // background-image: url('@/assets/images/banner.jpg');
  // background-size: cover;
  // background-position: top center;
  padding: 20px;
  opacity: 1;
  // min-height: calc(100vh - 64px - 100px);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  align-content: center;
  position: relative;
}

// Add Background Image To Search Page
.error_background_div::before {
  content: '';
  background-image: url('@/assets/images/banner.jpg');
  background-size: cover;
  background-position: top center;
  opacity: 0.8;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  position: absolute;
  z-index: 0;
}
</style>
